<ngx-spinner 
  bdColor = "rgba(0, 0, 0, 0.8)" 
  size = "medium" 
  color = "#fff" 
  type = "ball-atom" 
  [fullScreen] = "true"
>
  <p style="color: white" > {{ 'LOADING' | translate }}... </p>
</ngx-spinner>
<div class="mainContent">
    <h2 mat-dialog-title>{{ 'CANDIDATETYPE' | translate }}</h2>
    <mat-dialog-content class="mat-typography">
        <p>{{ 'SELECTCANDIDATETYPE' | translate }}</p>

        <form [formGroup]="candidateForm" (ngSubmit)="onSubmit()">

            <mat-radio-group formControlName="serviceType_Id">
                <mat-radio-button *ngFor="let type of serviceTypes" [value]="type.id">
                    {{ type.servicetypename | translate }}
                </mat-radio-button>
            </mat-radio-group>

            <!-- División (Select) -->
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ 'DIVISION' | translate }}</mat-label>
                <mat-select formControlName="division_Id" placeholder="{{ 'SELECTOPTION' | translate }}">
                    <mat-option *ngFor="let division of divisions" [value]="division.id">
                        {{ division.clientdivisionname }}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="candidateForm.get('division_Id')?.invalid">
                    {{ 'REQUIREDFIELD' | translate }}
                </mat-error>
            </mat-form-field>

            <!-- Nombres -->
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ 'NAME' | translate }}</mat-label>
                <input matInput formControlName="name" placeholder="{{ 'NAME' | translate }}">
                <mat-error *ngIf="candidateForm.get('name')?.invalid">
                    {{ 'REQUIREDFIELD' | translate }}
                </mat-error>
            </mat-form-field>

            <!-- Primer Apellido -->
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ 'FIRSTLASTNAME' | translate }}</mat-label>
                <input matInput formControlName="firstLastName" placeholder="{{ 'ENTERFIRSTLASTNAME' | translate }}">
                <mat-error *ngIf="candidateForm.get('firstLastName')?.invalid">
                    {{ 'REQUIREDFIELD' | translate }}
                </mat-error>
            </mat-form-field>

            <!-- Segundo Apellido -->
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>{{ 'SECONDLASTNAME' | translate }}</mat-label>
                <input matInput formControlName="secondLastName" placeholder="{{ 'ENTERSECONDLASTNAME' | translate }}">
            </mat-form-field>
        </form>
    </mat-dialog-content>

    <!-- Botones -->
    <mat-dialog-actions align="end">
        <button type="button" mat-flat-button style="background-color: #6c757d; color: white;" (click)="closeDialog()">
            {{ 'CANCEL' | translate }}
        </button>
        <button type="submit" mat-flat-button style="background-color: #870424; color: white;" [disabled]="candidateForm.invalid" (click)="onSubmit()">
            {{ 'CONTINUE' | translate }}
        </button>
    </mat-dialog-actions>
</div>